<router-outlet></router-outlet>
@if (enableServiceSubscriber) {
    <frog-service-subscriber></frog-service-subscriber>
}
